module.exports = __webpack_public_path__ + "media/images/products/igood-desktop-a559504291ee3442cd9ac89ab773c472.png";